import axios from '../utils/axios';

export const addSchoolToWaitlist = async (data) => {
  const response = await axios.post('/auth/school/add-to-wait-list', data);
  return response.data;
};

export const addStudentToWaitlist = async (data) => {
  const response = await axios.post('/auth/student/add-to-wait-list', data);
  return response.data;
};

export const getSecurityQuestions = async () => {
  const response = await axios.get('/security-questions');
  return response.data;
};

export const getClasses = async () => {
  const response = await axios.get('/classes');
  return response.data;
};
